import { PLUGTYPE_NAMES, PLUGTYPES } from '../models/bff/station-data.interface';

export const getPlugTypeName = (plugType: string): string => {
  return PLUGTYPES[plugType];
};
export const getPlugTypeLabel = (plugType: string): string => {
  return PLUGTYPE_NAMES[plugType];
};

export const getPlugIllustration = (plugType: string): string => {
  return `/assets/img/plugs/${getPlugTypeName(plugType)}.svg`;
};
